<template>
  <div class="water-mark" :style="bgStyle"></div>
</template>

<script>

export default {
  name: 'WaterMark',
  props: {
    width: {
      type: Number,
      default: 280,
    },
    height: {
      type: Number,
      default: 280,
    },
    rotate: {
      type: Number,
      default: -20, // 顺时针正值，逆时针负值
    },
    content: {
      type: String,
    },
    color: {
      type: String,
      default: 'rgba(0, 0, 0, 0.1)',
    },
    fontStyle: {
      type: String,
      default: '12px sans-serif',
    },
    baseStyle: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    bgStyle() {
      const baseStyle = Object.assign({
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        zIndex: 9999,
        pointerEvents: 'none',
        backgroundRepeat: 'repeat, repeat',
        overflow: 'hidden',
      }, this.baseStyle)
      const style = {
        ...baseStyle,
        backgroundImage: `url(${this.base64}),url(${this.base64})`,
        backgroundPosition: `${this.width / 2}px ${this.height / 2}px, 0 0`,
      };
      return style;
    },
  },
  data() {
    return {
      base64: '',
      isLark: /(lark|Lark)/i.test(navigator.userAgent)
    };
  },
  mounted() {
    // Hi ECARX端内不加载水印
    if (!this.isLark) {
      this.creatBase64();
      this.$nextTick(() => {
        this.lisenter()
      })
    }
  },
  methods: {
    creatBase64() {
      const text = this.content;
      const canvas = document.createElement('canvas');
      canvas.width = this.width;
      canvas.height = this.height;
      // const canvas = document.querySelector('#water');

      const ctx = canvas.getContext('2d');

      ctx.translate(canvas.width / 2, canvas.height / 2);// 将画布坐标系原点移至中心
      ctx.rotate(this.rotate * Math.PI / 180);
      ctx.translate(-canvas.width / 2, -canvas.height / 2);// 修正画布坐标系

      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.font = this.fontStyle;
      ctx.fillStyle = this.color;
      ctx.fillText(text, canvas.width / 2, canvas.height / 2);

      const dataURL = canvas.toDataURL();
      this.base64 = dataURL;
    },
    // DOM监控
    lisenter() {
      // TODO：节点删除不会重新渲染
      const watermark = this.$parent.$el.querySelector('.water-mark');
      const style = watermark.getAttribute('style');
      const observer = new MutationObserver((mutationsList) => {
        if (watermark && watermark.getAttribute('style') !== style) {
          watermark.setAttribute('style', style)
        }
      })
      observer.observe(watermark, {
        childList: true, // 子节点的变动（指新增，删除或者更改）
        attributes: true, // 属性的变动
        characterData: true, // 节点内容或节点文本的变动
        subtree: true, // 是否将该观察器应用于该节点的所有后代节点
      });
    }
  },
};
</script>
